/**
 * Created by wangmeng on 2017/5/18.
 */
import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

declare const wx: any;

@Injectable()
export class WxService {
  private wxApiList: string[] = [
    //分享接口
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone'
  ];

  constructor(private http: Http) {
  }

  init(shareOptions): Promise<any> {
    let url = encodeURIComponent(location.href.split('#')[0]);
    return new Promise(resolve => {
      this.getWxConfigTicket(url).subscribe(ticket => {
        let wxOption = {
          debug: false,
          appId: ticket.appId,
          timestamp: ticket.timestamp,
          nonceStr: ticket.nonceStr,
          signature: ticket.signature,
          beta: true,
          jsApiList: this.wxApiList
        };
        wx.config(wxOption);
        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: shareOptions.title,
            link: shareOptions.link,
            imgUrl: shareOptions.imgUrl,
            success: function () {
            },
            cancel: function () {
            },
          });
          wx.onMenuShareAppMessage({
            title: shareOptions.title,
            desc: shareOptions.desc,
            link: shareOptions.link,
            imgUrl: shareOptions.imgUrl,
            type: shareOptions.type,
            dataUrl: shareOptions.dataUrl,
            success: function () {
            },
            cancel: function () {
            },
          });
          wx.onMenuShareQQ({
            title: shareOptions.title,
            desc: shareOptions.desc,
            link: shareOptions.link,
            imgUrl: shareOptions.imgUrl,
            success: function () {
            },
            cancel: function () {
            },
          });
          wx.onMenuShareWeibo({
            title: shareOptions.title,
            desc: shareOptions.desc,
            link: shareOptions.link,
            imgUrl: shareOptions.imgUrl,
            success: function () {
            },
            cancel: function () {
            },
          });
          wx.onMenuShareQZone({
            title: shareOptions.title,
            desc: shareOptions.desc,
            link: shareOptions.link,
            imgUrl: shareOptions.imgUrl,
            success: function () {
            },
            cancel: function () {
            }
          });
        });
      });
    });
  }

  getWxConfigTicket(url: string): Observable<any> {
    return this.http.get(`/apiAuth?url=${url}`).map(this.extractData).catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.messsage ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/wx.service.ts